import { gql } from "@apollo/client"

export const DeleteSubscription = gql`
mutation DeleteSubscription($deleteSubscriptionId: ID!) {
  deleteSubscription(id: $deleteSubscriptionId) {
    status
  }
}
`